import * as actionTypes from '@store/actions/actionTypes'

const initialState = {
  steps: []
}

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.SET_TOUR:
      return {
        ...state,
        steps: action.steps,
        id: action.id
      }
    default:
      return state
  }
}

export default reducer
